export default "__VITE_ASSET__CWzR_TnR__"